<template>
  <div class="basic-info" :class="{ 'base-info__electron': isElectron }">
    <el-form
      ref="form"
      :model="form"
      label-width="150px"
      size="medium"
      :rules="rules"
    >
      <el-form-item label="头像">
        <el-upload
          accept=".jpg,.png"
          class="avatar-uploader"
          action="#"
          :auto-upload="false"
          :show-file-list="false"
          :on-change="handleChange"
        >
          <img v-if="form.avatar" :src="form.avatar" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input v-model="form.id" disabled></el-input>
      </el-form-item>
      <el-form-item label="昵称" prop="nickname">
        <el-input v-model.trim="form.nickname" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model.trim="form.name" :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item label="生日">
        <el-date-picker
          @change="datePickerChange"
          v-model="form.birthday"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="年龄">
        <p>
          <span class="age-wrap">{{ form.age !== "" ? form.age : "未知" }}</span
          >岁
        </p>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="form.gender">
          <el-radio :label="0">保密</el-radio>
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="联系电话" prop="contact_phone">
        <el-input v-model.trim="form.contact_phone" maxlength="16"></el-input>
        <span style="margin-left: 10px; color: #ccc"
          >非中国大陆用户请输入国际电话区号</span
        >
      </el-form-item>
      <el-form-item label="联系地址">
        <el-input
          v-model.trim="form.contact_address"
          maxlength="200"
          style="width: 80%"
        ></el-input>
      </el-form-item>
      <el-form-item class="form-footer">
        <el-button
          type="primary"
          size="medium"
          @click="submitForm"
          v-preventReClick
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { cosUploadFile } from "@saas/components/src/utils/cos-upload";
import { updateUser, getAvatarSts } from "@saas/service-api/src/user-info/index";
import { vailPhone } from "@saas/components/src/utils/utils.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data: function () {
    const validateMobile = (rule, value, callback) => {
      // 校验手机号 6-16位
      if (value && (value.length < 6 || value.length > 16)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    return {
      form: {
        gender: 0,
        age: "",
      },
      rules: {
        nickname: [{ required: true, message: "必填项", trigger: "blur" }],
        contact_phone: [{ validator: validateMobile, trigger: "blur" }],
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7; // 如果不想包括当前日期，减去一天的时间
        },
      },
      loading: false,
      avatarKey: "",
      isElectron: window.isElectron,
    };
  },
  mounted() {
    setTimeout(() => {
      this.inintFormData();
    }, 500);
  },
  methods: {
    ...mapActions(["getProfile"]),
    ...mapActions("user", ["getInfo"]),
    handleChange(file) {
      const isImageType = ["image/jpeg", "image/png"].includes(file.raw.type);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isImageType) {
        this.$message.warning("上传图片只能是 JPG、PNG 格式!");
        return false;
      }
      if (!isLt10M) {
        this.$message.warning("上传图片大小不能超过 10M!");
        return false;
      }
      this.getUploadFileSts(file);
    },
    // 获取凭证
    getUploadFileSts(file) {
      getAvatarSts({ filename: file.name }).then(async (res) => {
        if (res.code === 1) {
          this.avatarKey = res.data.key;
          cosUploadFile(
            {
              file: file.raw,
              fileName: file.name,
            },
            { ...res.data },
            {
              onTaskReady: (taskId) => {
                console.log("taskId>>>>", taskId);
              },
              onProgress: (progerssData) => {
                console.log("progerssData>>>>", progerssData);
              },
              onFileFinish: (err, data, options) => {
                console.log("onFileFinish-data", data);
                console.log("onFileFinish-options", options);
                if (data && data.statusCode === 200) {
                  this.form.avatar = data.Location.startsWith("https://")
                    ? data.Location
                    : "https://" + data.Location;
                  this.form.avatar = `${
                    this.form.avatar
                  }?t=${new Date().getTime()}`;
                } else {
                  console.log(err);
                }
              },
            }
          );
        }
      });
    },
    datePickerChange(value) {
      if (value) {
        let today = new Date(); // 获取当前日期时间
        let birthdate = new Date(value); // 将生日字符串转换为日期格式
        this.form.age = today.getFullYear() - birthdate.getFullYear(); // 根据年份计算年龄
        console.log(today.getFullYear() - birthdate.getFullYear());
      } else {
        this.form.age = "";
      }
    },
    inintFormData() {
      let {
        avatar,
        nickname,
        name,
        user_id,
        birthday,
        gender,
        contact_phone,
        contact_address,
      } = this.user;
      if (birthday) {
        // 计算年龄
        this.datePickerChange(birthday);
      }
      this.form = {
        ...this.form,
        id: user_id,
        avatar,
        nickname,
        name,
        birthday,
        gender,
        contact_phone,
        contact_address,
      };
    },
    submitForm() {
      //   校验
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.loading) return;
          this.loading = true;
          let params = {
            ...this.form,
          };
          if (this.avatarKey) {
            params.avatar = this.avatarKey;
          }
          updateUser({ ...params })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("修改成功");
                // 更新用户信息
                if (window.isElectron) {
                  this.getInfo();
                } else {
                  this.getProfile();
                }
              } else {
                this.$message.error(res.message);
              }
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>

<style lang="scss" scoped>
.basic-info {
  padding: 20px;
  background-color: #fff;
  border-radius: 16px;
  flex: 1;
  .el-form {
    ::v-deep .el-form-item__content > .el-input {
      width: 250px;
    }
    .age-wrap {
      margin-right: 20px;
    }
    .form-footer {
      text-align: right;
      padding-top: 20px;
      padding-right: 20px;
    }
  }
  // 上传组件
  .avatar-uploader {
    display: inline-block;
    width: 150px;
    height: 150px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader:hover {
    border-color: $saas-theme-color;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 150px;
    text-align: center;
  }
  .avatar {
    width: 150px;
    height: 150px;
    display: block;
  }
}
.base-info__electron {
  border-radius: 16px;
}
</style>
